// // class MarmetoFlickity extends HTMLElement {
// //   constructor() {
// //       super();
// //   }
// //   connectedCallback() {
// //       var flkty = new Flickity(this, {
// //           cellAlign: 'left',  
// //           contain: true,       
// //           wrapAround: true,    
// //           autoPlay: 3000, 
// //           prevNextButtons: true, 
// //           pageDots: true,      
// //           draggable: true  
// //       });
// //       setTimeout(() => {
// //       let firstDot = document.querySelector('.flickity-page-dots .dot');
// //       if (firstDot) {
// //           firstDot.classList.add('is-selected');
// //           firstDot.style.animation = 'circularProgress 3s linear forwards';
// //       }
// //     }, 500); 
// //       function resetProgress() {
// //           let dots = document.querySelectorAll('.flickity-page-dots .dot');
          
// //           dots.forEach(dot => {
// //               dot.classList.remove('is-selected');
// //               dot.style.animation = 'none'; 
// //               dot.style.opacity = "1";
// //               void dot.offsetWidth; 
// //           });
// //           let activeDot = document.querySelector('.flickity-page-dots .dot.is-selected');
// //           if (activeDot) {
// //               activeDot.style.animation = 'circularProgress 3s linear forwards';
// //           }
// //       }
      
// //       flkty.on('change', function() {
// //           setTimeout(resetProgress, 3000);
// //       });
     
// //       resetProgress();
// //   }
// // }

// // customElements.define("marmeto-flickity", MarmetoFlickity);


// class MarmetoFlickity extends HTMLElement {
//     constructor() {
//       super();
//     }
    
//     connectedCallback() {
//       // Initialize Flickity
//       var flkty = new Flickity(this, {
//         cellAlign: 'left',
//         contain: true,
//         wrapAround: true,
//         autoPlay: 3000,
//         prevNextButtons: true,
//         pageDots: true,
//         draggable: true
//       });
      
//       // Store the Flickity instance on the element
//       this.flkty = flkty;
      
//       // Reset progress on slide change
//       flkty.on('select', () => {
//         this.resetProgress();
//       });
      
//       // Initial setup after a short delay to ensure dots are created
//       setTimeout(() => {
//         this.resetProgress();
//       }, 100);
//     }
    
//     resetProgress() {
//       // Remove animation from all dots
//       let dots = document.querySelectorAll('.flickity-page-dots .dot');
//       dots.forEach(dot => {
//         dot.style.animation = 'none';
//         void dot.offsetWidth; // Force reflow
//       });
      
//       // Add animation only to the selected dot
//       let activeDot = document.querySelector('.flickity-page-dots .dot.is-selected');
//       if (activeDot) {
//         activeDot.style.animation = 'circularProgress 3s linear forwards';
//       }
//     }
//   }
  
//   customElements.define("marmeto-flickity", MarmetoFlickity);

class MarmetoFlickity extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        var flkty = new Flickity(this, {
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            autoPlay: 3000,
            prevNextButtons: true,
            pageDots: true,
            draggable: true
        });

        this.flkty = flkty;

        flkty.on('select', () => {
            this.resetProgress();
        });

        setTimeout(() => {
            this.resetProgress();
        }, 100);
    }

    resetProgress() {
        let dots = document.querySelectorAll('.flickity-page-dots .dot');
        dots.forEach(dot => {
            dot.innerHTML = ""; 
        });

        let activeDot = document.querySelector('.flickity-page-dots .dot.is-selected');
        if (activeDot) {
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", "40");
            svg.setAttribute("height", "40");
            svg.setAttribute("viewBox", "0 0 50 50");

            let circleBg = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circleBg.setAttribute("cx", "25");
            circleBg.setAttribute("cy", "25");
            circleBg.setAttribute("r", "18");
            circleBg.setAttribute("fill", "none");
            circleBg.setAttribute("stroke", "#ddd");
            circleBg.setAttribute("stroke-width", "3");

            let circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circle.setAttribute("cx", "25");
            circle.setAttribute("cy", "25");
            circle.setAttribute("r", "18");
            circle.setAttribute("fill", "none");
            circle.setAttribute("stroke", "black"); // Change color as needed
            circle.setAttribute("stroke-width", "3");
            circle.setAttribute("stroke-dasharray", "113");
            circle.setAttribute("stroke-dashoffset", "113");
            circle.setAttribute("stroke-linecap", "round");

            // Add animation to the circle
            circle.style.transition = "stroke-dashoffset 3s linear";
            setTimeout(() => {
                circle.setAttribute("stroke-dashoffset", "0");
            }, 50);

            svg.appendChild(circleBg);
            svg.appendChild(circle);
            activeDot.appendChild(svg);
        }
    }
}

customElements.define("marmeto-flickity", MarmetoFlickity);
